import { graphql } from '../../gql';

export const COMPOSITION_ENTITY_DATA = graphql(`
  query COMPOSITION_ENTITY_DATA($entities: [CompositionV2Entity!]!) {
    composition_v2(
      req: {
        entities: $entities
        filters: { raw: false, start_date: "2025-02", end_date: "2025-02" }
        breakdown_options: {}
      }
    ) {
      entities {
        metadata {
          id
          short_name
          long_name
          type
        }
      }
    }
  }
`);
